var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8436_16764)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#F4F5F6"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8436_16764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.9749 75.0001H21.8911C21.3895 75.0001 20.9085 74.806 20.5539 74.4603C20.1992 74.1148 20 73.6463 20 73.1577L24.4064 71.7595H73.2614L80.8622 73.1577C80.8622 73.6456 80.6637 74.1138 80.3098 74.4593C79.9559 74.8047 79.4757 74.9991 78.9749 75.0001Z",
    fill: "#84D3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7146 31H72.1589C72.3062 31 72.4518 31.0282 72.5879 31.0831C72.7237 31.138 72.8474 31.2184 72.9516 31.3198C73.0557 31.4212 73.1383 31.5416 73.1946 31.6741C73.2508 31.8066 73.2798 31.9486 73.2798 32.092V59.6551H27.5938V32.092C27.5938 31.8024 27.7118 31.5246 27.922 31.3198C28.1322 31.115 28.4173 31 28.7146 31Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5235 34.052H30.332V57.6455H70.5235V34.052Z",
    fill: "#84D3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2685 59.655H27.5936L20 73.1608H80.8622L73.2685 59.655Z",
    fill: "#9057F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2058 60.7791H31.3977L30.6055 62.1876H35.6837L36.2058 60.7791Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2603 62.1876L69.4646 60.7791H64.9375L65.5509 62.1876H70.2603Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8876 62.1876L40.2052 60.7791H37.0766L36.5508 62.1876H39.8876Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0995 68.416L26.1211 70.1589L32.7107 70.1694L33.3642 68.416H27.0995Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6768 62.1876L64.0634 60.7791H60.9531L61.3946 62.1876H64.6768Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.535 62.1876L60.0895 60.7791H56.9609L57.2164 62.1876H60.535Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0543 62.1876L48.1383 60.7791H45.0351L44.8672 62.1876H48.0543Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2652 62.1876L52.1375 60.7791H48.9941L48.9102 62.1876H52.2652Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3583 62.1876L56.1025 60.7791H52.9922L53.12 62.1876H56.3583Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0136 62.1876L44.1815 60.7791H41.0638L40.7461 62.1876H44.0136Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0381 70.2479L74.799 70.262L73.7624 68.416H68.2461L69.0381 70.2479Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0634 67.996H73.5248L72.6742 66.481H67.4062L68.0634 67.996Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3594 68.416L63.936 70.2371L68.1635 70.2479L67.3716 68.416H63.3594Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7305 62.6074L66.3877 64.1228H71.3492L70.4949 62.6074H65.7305Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2355 68.416L33.582 70.1731L38.0835 70.1839L38.485 68.416H34.2355Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3398 68.416L58.6647 70.2266L63.0712 70.2371L62.498 68.416H58.3398Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.343 68.416L38.9414 70.1839L43.0558 70.1944L43.2713 68.416H39.343Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4038 68.3948L44.1257 68.4161L43.9141 70.1945L57.7324 70.2053L57.4038 68.3948Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9883 66.481L58.2623 67.996H62.3621L61.8839 66.481H57.9883Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.75 66.481L63.2282 67.996H67.1895L66.5323 66.481H62.75Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6406 64.5461L57.9146 66.0615H61.7553L61.2767 64.5461H57.6406Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5815 64.5461H62.1406L62.6189 66.0615H72.4358L71.5815 64.5461Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5312 62.6074L62.0095 64.1228H65.5141L64.8569 62.6074H61.5312Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.293 62.6074L57.567 64.1228H61.1447L60.6665 62.6074H57.293Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5156 66.481L53.658 67.996H57.4074L57.1337 66.481H53.5156Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3398 64.5461L53.4786 66.0615H57.0564L56.7864 64.5461H53.3398Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1602 62.6074L53.2989 64.1228H56.7086L56.4349 62.6074H53.1602Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6499 66.481L48.5586 67.996H52.8008L52.6584 66.481H48.6499Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.767 64.5461L48.6758 66.0615H52.6223L52.4836 64.5461H48.767Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8842 62.6074L48.793 64.1228H52.4438L52.3051 62.6074H48.8842Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1758 67.996H47.7061L47.7973 66.481H44.3547L44.1758 67.996Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4062 66.0615H47.8234L47.9147 64.5461H44.5888L44.4062 66.0615Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6406 64.1228H47.9409L48.0322 62.6074H44.8195L44.6406 64.1228Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4375 67.996H43.3219L43.5008 66.481H39.777L39.4375 67.996Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8711 66.0615H43.5511L43.7337 64.5461H40.2142L39.8711 66.0615Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3086 64.1228H43.7841L43.963 62.6074H40.6517L40.3086 64.1228Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1903 66.481L27.3359 67.996H38.5731L38.9162 66.481H28.1903Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1094 66.0615H39.0121L39.3553 64.5461H35.6716L35.1094 66.0615Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7907 62.6074H30.368L28.4258 66.0611H34.2415L34.9607 64.1228H39.4512L39.7907 62.6074Z",
    fill: "#AD81F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4301 33.3475C50.8576 33.3475 51.2042 33.0099 51.2042 32.5934C51.2042 32.177 50.8576 31.8394 50.4301 31.8394C50.0027 31.8394 49.6562 32.177 49.6562 32.5934C49.6562 33.0099 50.0027 33.3475 50.4301 33.3475Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8436_16764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8436_16764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 44,
    fill: "white",
    transform: "translate(20 31)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.5ba5dece83b4170a132cd94229401cda.svg";
export { ForwardRef as ReactComponent };